/**
 * @file Defines the {@link Values} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** 
  * Class for handling a fixed set of values
  */
  export class Values {

    /**
     * Stores index for current value in values array
     * @memberof Values
     * @protected
     * @instance
     * @type {number}
     */
    _index
    
    /**
     * Array containing all possible values
     * @memberof Values
     * @protected
     * @instance
     * @type {Array}
     */
    _values

    constructor() {}

    /** Get index */  get index()  { return this._index }
    /** Get values */ get values() { return this._values }

    /**
     * Decrease value
     */
    decrease() {

        //If index is not as minimum
        if (this._index > 0) {
            this._index-- //Decrement index
        }

    }

    /**
     * Increase value
     */
    increase() {

        //If index is not at maximum
        if (this._index < this._values.length - 1) {
            this._index++ //Increment index         
        }

    }

    /**
     * Increase to max value
     */
    max() {
        this._index = this._values.length - 1
    }
    
    /**
     * Returns current value
     * @return {*} Current value
     */
    value() {
        return this._values[this._index]        
    }

  }